/**
 * Served surface key -> this app's palette id. A PLAIN module on purpose
 * (no "use client"): the root layout is a Server Component and must decide
 * `data-brand` at request time (#411), and a function exported from a
 * "use client" module cannot be called from the server — Next refuses with
 * "Attempted to call brandIdForSurface() from the server" (measured
 * 2026-09-07 against a local dev server). ExperienceProvider re-exports
 * these for the existing client importers.
 */
import { DEFAULT_BRAND, type BrandId } from "../ui/tokens";

/** An unknown surface (a future experience with no palette here yet) keeps
 *  the default palette rather than guessing — and is surfaced on the
 *  context so a consumer CAN tell "default" from "unknown-but-served". */
export const SURFACE_TO_BRAND: Readonly<Record<string, BrandId>> = {
  zoomwarriors: "zw",
  vip: "vip",
};

/** The one surface-key -> palette-id mapping, for consumers that resolve
 *  an experience OUTSIDE the served-host bootstrap (e.g. the anonymous
 *  intake page labels itself from the minting partner's surface, carried
 *  on the resolve payload). Unknown/empty keys get the platform default. */
export function brandIdForSurface(key: string | null | undefined): BrandId {
  return (key && SURFACE_TO_BRAND[key]) || DEFAULT_BRAND;
}
